export default "__VITE_ASSET__DWGrFt7b__"